module.exports = __webpack_public_path__ + "img/logo.020e7cba.svg";